import { Button, Stack } from "@mui/material";
import UploadFileForm from "components/files/UploadFileForm";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import FileSelector from "components/files/FileSelector";

export default function AttachFileForm({
  successCallback = ({ fileId, fileData }) => {},
}) {

  const [useExisting, setUseExisting] = useState(false);
  const [createNew, setCreateNew] = useState(false);

  const renderForm = () => {
    if (useExisting) {
      return <FileSelector selectCallback={successCallback} />;
    }

    if (createNew) {
      return <UploadFileForm successCallback={successCallback} />;
    }

    return (
      <Stack spacing={2}>
        <Button
          variant="contained"
          onClick={() => setUseExisting(true)}
          startIcon={<SearchIcon />}
        >
          Selecting Existing File
        </Button>
        <Button
          variant="contained"
          onClick={() => setCreateNew(true)}
          startIcon={<AddIcon />}
        >
          Create New
        </Button>
      </Stack>
    );
  };

  return (
    <Stack spacing={1} py={1}>
      {renderForm()}
      {(useExisting || createNew) && (
        <Button
          color="secondary"
          variant="contained"
          onClick={() => {
            setCreateNew(false);
            setUseExisting(false);
          }}
          startIcon={<ArrowBackIosIcon />}
        >
          Back
        </Button>
      )}
    </Stack>
  );
}
